import Cookies from 'js-cookie';
import Service from '../../service/Service';
const service = new Service();

export function getDate(date) {
    let d = new Date(date);
    let mth = d.getMonth();
    let dt = d.getDate();
    let yr = d.getFullYear();
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    let newdate = monthNames[mth] + " " + dt + ", " + yr;
    return newdate;
}

export function gotoBabyname(babyname, shortlist) {
    if (global.ftk != '') {
        var redirectUrl = window.location.protocol+"//"+window.location.host+"/baby-names/meaning-of-"+babyname.replace(/-/g, "").replace(/ /g, "-").toLowerCase()+"/?shortlist="+shortlist;
        window.location.href = redirectUrl;
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

export function gotoQnaAns(qna) {
    if (global.ftk != '') {
        var redirectUrl = window.location.protocol+"//"+window.location.host+"/qna/q/"+qna+"/post_answer=1";
        window.location.href = redirectUrl;
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

// export function gotoQnaFllow(qna) {
//     var redirectUrl = window.location.protocol+"//"+window.location.host+"/qna/q/"+qna+"/?follow=1";
//     window.location.href = redirectUrl;
// }
export function saveQueActions(status, queId, creaId, queTitle, actionType, eleRef) {
    // debugger;
    if (global.ftk != '') {
        if (global.userAry['IsTryingToConceive'] == 1 || (global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'].length > 0)) {
            service.showLoader();
            var postData = {
                "childinfo": global.userAry['childData']['UserChildList'],
                "question_type": 1,
                "action_status": status + "",
                "action_type": actionType,
                "creater_id": creaId + "",
                "question_id": queId,
                "user_type": global.userAry['Sex'],
                "que_type": "child",
                "question_title": queTitle,
                "expecting_dob": global.userAry['expectedDob'],
                "IsTryingToConceive": global.userAry['IsTryingToConceive']
            }
            var url = global.api_ci_url + "qna/saveQueActions";
            service.postServiceCall(url, postData).then((json) => {
                // debugger;
                console.log(eleRef.state.searchData);
                var searchindex;
                // eleRef.state.searchData.every((search, index) => {
                for(let i = 0; i < eleRef.state.searchData.length; i++){
                    // console.log("search.type -- ",search.type);
                    if(eleRef.state.searchData[i].type == "qna"){
                        searchindex = i;
                        break;
                    }
                }
                var newData = eleRef.state.searchData;
                newData[searchindex].data.forEach((que) => {
                    // console.log(que);
                    if(que.question_id == queId){
                        if(status == 1){
                            que.follow_count = parseInt(que.follow_count) + 1;
                            que.que_follow = true;
                        } else{
                            que.follow_count = parseInt(que.follow_count) - 1;
                            que.que_follow = false;
                        }
                    }
                });
                eleRef.setState({searchData: newData});
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
            return true;
        } else {
            service.showAlert("Please Complete Your Child Profile");
            window.location.href = '/my-account?URL=' + global.currentURL;
            return false;
        }
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

export function redirectToYoutube() {
    service.showAlert('You are now being redirected to FirstCry Youtube Channel.');
    window.open("https://www.youtube.com/user/firstcrydotcom?sub_confirmation=1", "_blank");
}
export function shareArticle(shareoption, articleurl) {
    var shareurl;
    let ary = document.getElementsByClassName('sharing-options');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    if (document.getElementsByClassName('share-overlay')[0]) {
        document.getElementsByClassName('share-overlay')[0].style.display = 'none';
    }
    if (shareoption == "facebook") {
        shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
    } else if (shareoption == "twitter") {
        shareurl = 'https://twitter.com/share?url=';
    } else if (shareoption == "pintrest") {
        shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
    } else if (shareoption == "whatsapp") {
        shareurl = 'whatsapp://send?text=';
    }
    var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
    if (sharewindow.focus) {
        sharewindow.focus();
    }
    return false;
}
export function shareOn(id) {
    let ary = document.getElementsByClassName('sharing-options');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    document.getElementById('share_' + id).getElementsByClassName('sharing-options')[0].style.display = 'block';
    if (window.innerWidth < 767) {
        if (document.getElementsByClassName('share-overlay')[0]) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'block';
        }
    }
}
export function domClick(event) {
    // debugger;
    if (!event.target.classList.contains('share-click')) {
        let ary = document.getElementsByClassName('sharing-options');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
        if (document.getElementsByClassName('share-overlay')[0]) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'none';
        }
    }
}

var playList = [];
export function onPlayerStateChange(event, id, eleRef) {
    // debugger;
    console.log("event : ",event);
    // console.log("event : ",id);
    // console.log(event.target.playerInfo.videoData);
    // console.log(event.target.f.offsetParent);
    // let id = event.target.f.offsetParent.getAttribute('data-id');
    // if (event.data == 3) {
    //     playList.push(id);
    // } else if (event.data == 1 && playList.includes(id)) {
    //     saveVideoAction(id, "view", "1", eleRef);
    // }
    if (event.data == 3 && !playList.includes(id)) {
        document.getElementById("videodet-"+id).style.display = "none";
        playList.push(id);
        saveVideoAction(id, "view", "1");
    }
}

export function saveVideoAction(id, type, status, eleRef) {
    // debugger;
    if (global.ftk != '' || type=="view") {
        if(status == 1){
            if (type == "like") {
                service.showLoader();
            }
            let gender = 'NA';
            let genderNo = '';
            if (global.userAry['Sex'] && global.userAry['Sex'] != '') {
                gender = global.userAry['Sex'];
                genderNo = gender.toLowerCase() == 'male' ? 0 : 1;
            }
            let childAry = [];
            global.userAry['childData'] && global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'].forEach((child) => {
                let obj = {};
                obj["gender"] = child['Gender'].toLowerCase();
                obj["dob"] = child['DOB'];
                obj["childId"] = child['ChildId'];
                obj["childName"] = child['ChildName'];
                obj["childPic"] = child['childPhoto'];
                childAry.push(obj);
            })
            var postData = {
                "videoId": id,
                "action_type": type,
                "action_status": status.toString(),
                "userPic": global.userAry['userPhoto'],
                "userName": global.userAry['userName'],
                "userGender": genderNo,
                "childArr": childAry,
            }
            var url = global.api_ci_url + "Videos/saveVideoAction";
            service.postServiceCall(url, postData).then((json) => {
                // console.log(json);
                if (parseInt(json['msg']) == 1) {
                    changeData(id, type, status, eleRef);
                } else {
                    service.showAlert("Fail");
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        }
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

export function changeData(id, type, status, eleRef) {
    let videoData =[];
    var searchData = eleRef.state.searchData;
    for (var j of Object.keys(searchData)){
        if(searchData[j]['type'] == "videos"){
            videoData = searchData[j];
            break;
        }
    }
    
    videoData.video && videoData.video.forEach((video) => {
        if (video.videoId == id) {
            if (type == "view") {
                if (parseInt(status) == 1) {
                    video.viewCount = parseInt(video.viewCount) + 1;
                }
            } else if (type == "like") {
                if (parseInt(status) == 1) {
                    video.isLike = true;
                    video.likeCount = parseInt(video.likeCount) + 1;
                } else if (parseInt(status) == 0) {
                    video.isLike = false;
                    video.likeCount = parseInt(video.likeCount) - 1;
                }
            } 
            // else if (type == "bookmark") {
            //     if (parseInt(status) == 1) {
            //         video.isBookmarked = true;
            //         video.bookmarkCount = parseInt(video.bookmarkCount) + 1;
            //     } else if (parseInt(status) == 0) {
            //         video.isBookmarked = false;
            //         video.bookmarkCount = parseInt(video.bookmarkCount) - 1;
            //     }
            // }
        }
    });
    eleRef.setState({ videosData: videoData });
}

var babynameId_array = [];
export function tonamedetails(event,recordId, babyname) {
    // debugger;
    var urlpath = window.location.href;
    var queryparamarray = urlpath.split("/");
    var queryparam = queryparamarray[4];

    var urlsrt = window.location.href;

    var discussion_page = window.location.pathname.split('/');

    if(document.getElementById("myInputdesk")){
        document.getElementById("myInputdesk").value = '';
    }

    if(!Cookies.get("babynamemeaning")){
        babynameId_array.push(recordId + "-" + babyname);
        Cookies.set("babynamemeaning", babynameId_array);

        localStorage.setItem("babynamemeaning", babynameId_array);
    } else {
        var tempArra = [];
// debugger;
        tempArra.push(Cookies.get("babynamemeaning").replace(/%2C/g, ",").replace(/"/g, '').slice(1,-1).split(",")[0]);
        tempArra.push(recordId + "-" + babyname);
        localStorage.setItem("babynamemeaning", tempArra);
        Cookies.set("babynamemeaning", tempArra);
    }
}

export function likeArticle(section, artiID, sectType, eleRef, e) {
    // debugger;
    let cls = e.target;
    // console.log("likeArticle===============>", cls);
    if(!cls.className.includes("activelike")){
        if (global.ftk !== '') {
            service.showLoader();
            let postData;
            let url;
            if(section == "babydiet"){
                postData = {
                    "stageId": "0",
                    "articleId": artiID,
                    "actionStatus": "1"
                }
                url = global.api_ci_url + "DietplanBaby/getLikeAction";
            } else if(section == "g&d") {
                postData = {
                    "actionStatus": "1",
                    "stageId": "0",
                    "articleId": artiID,
                    "moduleType": "babygrowthplan"
                }
                url = global.api_ci_url + "UniversalSearch/getGnDLikeAction";
            } else if(section == "pregnancydiet") {
                postData = {
                    "articleId": artiID,
                    "actionStatus": "1",
                    "moduleType": "momdietplan"
                }
                url = global.api_ci_url + "WeekByWeekGuide/getWeekByWeekLike";
            } else if(section == "pregweek") {
                postData = {
                    "articleId": artiID,
                    "actionStatus": "1",
                }
                url = global.api_ci_url + "WeekByWeekGuide/getWeekByWeekLike";
            }
            
            service.postServiceCall(url, postData).then((json) => {
                service.hideLoader();
                if (json['result'] == "success") {
                    cls.classList.add('activelike');
                    let likecnt = parseInt(cls.nextSibling.children[0].innerText) + 1;
                    cls.nextSibling.children[0].innerText = likecnt;

                    // updateData(artiID, sectType, eleRef);
                    // var newData = eleRef.state.searchData;
                    
                }
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
            return true;
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }
}

// function updateData(articleID, type, eleRef) {
//     var searchType = window.location.pathname.split('/')[2].split('-').join(' ');
//     var searchkey = window.location.pathname.split("/")[3].split('-').join(' ');
//     var url = global.api_ci_url + "UniversalSearch/getUniversalSearchData";
//     if(searchType == "all"){
//         var postdata = {
//             "pagesize" : 3,
//             "pageno" : 1,
//             "searchkey" : searchkey
//         }
//     }else{
//         var postdata = {
//             "pagesize" : 3,
//             "pageno" : 1,
//             "searchkey" : searchkey,
//             "type": searchType
//         }
//     }
//     service.postServiceCall(url, postdata).then((json) => {
//         if (json['msg'] == "1") {
//             var prevData = eleRef.state.searchData;
//             var recordsarray, index;
//             // console.log("new data ::: ", newData[j][sectType]);
//             if(type == "dietPlan"){
//                 recordsarray = 'dietPlanTools';
//             } else if(type == "pregnancyDiet"){
//                 recordsarray = 'PregnancyDietPlanTools';
//             } else if(type == "babyGroth"){
//                 recordsarray = 'babyGrothDevTools';
//             } else if(type == "pregnancyweek"){
//                 recordsarray = 'PregnancyWeekByWeekTools';
//             }
//             for (let i of Object.keys(prevData)){
//                 if(type == prevData[i]['type']) {
//                     for(let rec of prevData[i][recordsarray]){
//                         if(rec.articleId == articleID){
//                             rec.likeCount = json['result'][i][recordsarray]['likeCount'];
//                         }
//                         // console.log("rec --- ", rec);
//                     }
//                     break;
//                 }
//             }
//             // index = parseInt(index)
            
//             eleRef.setState({ searchData: prevData });
//         }
//         service.hideLoader();
//     }).catch((error) => {
//         console.error(error);
//         service.hideLoader();
//     });
// }

export function viewArticle(section, stageId, articleId, articleUrl, e) {
    let postData, url;
    if(section == "babydiet"){
        postData = {
            "articleId": articleId,
            "actionStatus": "1",
            "stageId": "0",
        }
        url = global.api_ci_url + "DietplanBaby/getViewAction"; 
    } else if(section == "g&d") {
        postData = {
            "articleId": articleId,
            "post_status": "publish"
        }
        url = global.api_ci_url + "UniversalSearch/getGnDViewAction";
    } else if(section == "pregnancydiet") {
        postData = {
            "articleId": articleId,
            "actionStatus": "1",
            "stageId": "0",
            "moduleType": "momdietplan"
        }
        url = global.api_ci_url + "DietplanMom/getViewAction";
    } else if(section == "pregweek") {
        postData = {
            "articleId":articleId,
            "post_status":"publish"
        }
        url = global.api_ci_url + "WeekByWeekGuide/getWeekByWeekViewArticle";
    }

    let cls = e.target;
    service.postServiceCall(url, postData).then((json) => {
        if (json['result'] == "success" || json['msg'] == "1") {
            // cls.classList.add('activelike');
            var thiViewElement = document.querySelector(`#article-${articleId}`).querySelector(".view-count");
            let viewcnt = parseInt(thiViewElement.innerText) + 1;
            thiViewElement.innerText = viewcnt;
            window.location.href = articleUrl;
        }
    }).catch((error) => {
        console.error(error);
        service.hideLoader();
    });
}
export function nonLoggedin(){
    service.showAlert("Please Login");
    window.location.href = global.loginUrl + '?URL=' + global.currentURL;
}

export function joinGroup(groupID, groupCatgID){
    if(global.ftk){
        let postData = {
            "type": 1,
            "groupId": groupID,
            "categoryId": groupCatgID,
        }
        var url = global.api_ci_url + "UniversalSearch/joinGroup";
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                window.location.reload();
            }
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
    }
}
